// Capelli — zoom: flechas laterales (front/back) + botón cerrar propio, sin miniaturas.
(function () {
  function visibleSlides(dlg) {
    return Array.from(dlg.querySelectorAll('.dialog-zoomed-gallery > li.product-media-container'))
      .filter(function (l) { return getComputedStyle(l).display !== 'none'; });
  }
  // Slide mas cercano al centro de la pantalla: sirve para el visor vertical (desktop) y el horizontal (celular).
  function currentIndex(slides) {
    var midX = window.innerWidth / 2, midY = window.innerHeight / 2, best = 0, bestD = Infinity;
    slides.forEach(function (s, i) {
      var r = s.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - midX) + Math.abs((r.top + r.height / 2) - midY);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }
  function go(dlg, dir) {
    resetZoom(dlg, false);
    var slides = visibleSlides(dlg);
    if (slides.length < 2) return;
    var i = Math.max(0, Math.min(slides.length - 1, currentIndex(slides) + dir));
    slides[i].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
  }
  function closeDialog(dlg) {
    var native = dlg.querySelector('.close-button');
    if (native) { native.click(); return; }
    if (dlg.close) dlg.close();
  }
  // ===== Celular: zoom como el visor de Capelli =====
  // Doble toque = acercar 2,5x en el punto tocado (otro doble toque vuelve); pellizco = zoom 1x-4x;
  // con la foto acercada, un dedo la arrastra. Sin zoom, el dedo desliza entre fotos (scroll-snap nativo).
  // Horizon (drag-zoom-wrapper) hace preventDefault en cada toque y abre con 1,5x: le cortamos los toques y
  // usamos sus mismas variables (--drag-zoom-scale/translate) que la imagen ya aplica: scale(s) translate(t).
  var ZOOM_STEP = 2.5, ZOOM_MAX = 4, TAP_MS = 300, TAP_PX = 30;
  var ZOOM_TARGET = 'drag-zoom-wrapper, .product-media__drag-zoom-wrapper';
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function slideOf(target) { return target && target.closest ? target.closest('li.product-media-container') : null; }
  function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
  function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }
  function startZoomState(dlg, li) {
    var wrap = li.querySelector(ZOOM_TARGET);
    if (!wrap) return null;
    if (dlg.__capZoom && dlg.__capZoom.li === li) return dlg.__capZoom;
    if (dlg.__capZoom) resetZoom(dlg, false);
    var r = wrap.getBoundingClientRect(); // el contenedor no se transforma (la escala va en la imagen)
    dlg.__capZoom = { li: li, wrap: wrap, left: r.left, top: r.top, w: r.width, h: r.height, s: 1, tx: 0, ty: 0 };
    return dlg.__capZoom;
  }
  function applyZoom(st, animate) {
    var cx = st.w / 2, cy = st.h / 2, lim;
    st.s = Math.max(1, Math.min(ZOOM_MAX, st.s));
    lim = (st.s - 1) / st.s;
    st.tx = Math.max(-cx * lim, Math.min(cx * lim, st.tx));
    st.ty = Math.max(-cy * lim, Math.min(cy * lim, st.ty));
    st.wrap.classList.toggle('cap-zoom-anim', !!animate);
    st.wrap.style.setProperty('--drag-zoom-scale', String(st.s), 'important');
    st.wrap.style.setProperty('--drag-zoom-translate-x', st.tx + 'px', 'important');
    st.wrap.style.setProperty('--drag-zoom-translate-y', st.ty + 'px', 'important');
  }
  // Cambia la escala manteniendo bajo el dedo el mismo punto de la foto (fx, fy relativos al recuadro).
  function zoomAround(st, fx, fy, s2) {
    var dx = fx - st.w / 2, dy = fy - st.h / 2;
    st.tx = dx / s2 - dx / st.s + st.tx;
    st.ty = dy / s2 - dy / st.s + st.ty;
    st.s = s2;
  }
  function resetZoom(dlg, animate) {
    var st = dlg && dlg.__capZoom;
    if (!dlg) return;
    dlg.__capZoom = null;
    dlg.classList.remove('cap-zoom-active');
    if (!st) return;
    st.s = 1; st.tx = 0; st.ty = 0;
    applyZoom(st, animate);
    setTimeout(function () {
      if (dlg.__capZoom && dlg.__capZoom.wrap === st.wrap) return;
      ['--drag-zoom-scale', '--drag-zoom-translate-x', '--drag-zoom-translate-y'].forEach(function (p) { st.wrap.style.removeProperty(p); });
      st.wrap.classList.remove('cap-zoom-anim');
    }, animate ? 260 : 0);
  }
  function bindZoomGestures(dlg) {
    var g = { startT: 0, startX: 0, startY: 0, moved: false, panX: 0, panY: 0, lastTapT: 0, lastTapX: 0, lastTapY: 0, pinch: null };
    function shield(e) { if (e.target && e.target.closest && e.target.closest(ZOOM_TARGET)) e.stopPropagation(); }
    function onStart(e) {
      if (!isMobile()) return;
      var li = slideOf(e.target);
      if (!li) return;
      shield(e);
      var t = e.touches;
      if (t.length === 2) {
        var st = startZoomState(dlg, li);
        if (!st) return;
        var m = mid(t);
        g.pinch = { d: dist(t[0], t[1]) || 1, s: st.s, mx: m.x, my: m.y };
        g.moved = true;
        if (e.cancelable) e.preventDefault();
      } else if (t.length === 1) {
        g.startT = Date.now(); g.startX = t[0].clientX; g.startY = t[0].clientY; g.moved = false;
        g.panX = t[0].clientX; g.panY = t[0].clientY;
      }
    }
    function onMove(e) {
      if (!isMobile()) return;
      var li = slideOf(e.target);
      if (!li) return;
      shield(e);
      var t = e.touches, st = dlg.__capZoom;
      if (t.length === 2 && g.pinch && st) {
        if (e.cancelable) e.preventDefault();
        var m = mid(t);
        var s2 = Math.max(1, Math.min(ZOOM_MAX, g.pinch.s * dist(t[0], t[1]) / g.pinch.d));
        zoomAround(st, m.x - st.left, m.y - st.top, s2);
        st.tx += (m.x - g.pinch.mx) / st.s;
        st.ty += (m.y - g.pinch.my) / st.s;
        g.pinch.mx = m.x; g.pinch.my = m.y;
        applyZoom(st, false);
        dlg.classList.add('cap-zoom-active');
      } else if (t.length === 1) {
        if (Math.abs(t[0].clientX - g.startX) > 10 || Math.abs(t[0].clientY - g.startY) > 10) g.moved = true;
        if (st && st.s > 1.01) {
          if (e.cancelable) e.preventDefault();
          st.tx += (t[0].clientX - g.panX) / st.s;
          st.ty += (t[0].clientY - g.panY) / st.s;
          g.panX = t[0].clientX; g.panY = t[0].clientY;
          applyZoom(st, false);
        }
      }
    }
    function onEnd(e) {
      if (!isMobile()) return;
      var li = slideOf(e.target);
      if (!li) return;
      shield(e);
      var st = dlg.__capZoom;
      if (g.pinch && e.touches.length < 2) {
        g.pinch = null;
        g.lastTapT = 0;
        if (st && st.s < 1.05) resetZoom(dlg, true);
        if (e.touches.length === 1) { g.panX = e.touches[0].clientX; g.panY = e.touches[0].clientY; }
        return;
      }
      if (e.touches.length !== 0 || g.moved || Date.now() - g.startT > 250) return;
      var now = Date.now();
      if (now - g.lastTapT < TAP_MS && Math.abs(g.startX - g.lastTapX) < TAP_PX && Math.abs(g.startY - g.lastTapY) < TAP_PX) {
        g.lastTapT = 0;
        if (e.cancelable) e.preventDefault(); // sin click fantasma ni zoom nativo del doble toque
        if (st && st.s > 1.01) {
          resetZoom(dlg, true);
        } else {
          st = startZoomState(dlg, li);
          if (!st) return;
          zoomAround(st, g.startX - st.left, g.startY - st.top, ZOOM_STEP);
          applyZoom(st, true);
          dlg.classList.add('cap-zoom-active');
        }
      } else {
        g.lastTapT = now; g.lastTapX = g.startX; g.lastTapY = g.startY;
      }
    }
    dlg.addEventListener('touchstart', onStart, { capture: true, passive: false });
    dlg.addEventListener('touchmove', onMove, { capture: true, passive: false });
    dlg.addEventListener('touchend', onEnd, { capture: true, passive: false });
    dlg.addEventListener('touchcancel', onEnd, { capture: true, passive: false });
    dlg.addEventListener('close', function () { resetZoom(dlg, false); });
  }
  function ensureControls(dlg) {
    if (!dlg.__capControls) {
      dlg.__capControls = true;
      [['prev', -1, 'Anterior'], ['next', 1, 'Siguiente']].forEach(function (a) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cap-zoom-arrow cap-zoom-arrow--' + a[0];
        btn.setAttribute('aria-label', a[2]);
        btn.addEventListener('click', function (e) { e.stopPropagation(); go(dlg, a[1]); });
        dlg.appendChild(btn);
      });
      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'cap-zoom-close';
      close.setAttribute('aria-label', 'Cerrar');
      close.addEventListener('click', function (e) { e.stopPropagation(); closeDialog(dlg); });
      dlg.appendChild(close);
      bindZoomGestures(dlg);
    }
    var many = visibleSlides(dlg).length > 1;
    dlg.querySelectorAll('.cap-zoom-arrow').forEach(function (b) { b.style.display = many ? '' : 'none'; });
  }
  // Celular: Horizon cierra el visor con cualquier toque sobre la foto (on:click="/close" en cada li), asi que el
  // primer toque del doble toque lo cerraba. Se corta ese click en la captura de window, antes de su delegacion.
  window.addEventListener('click', function (e) {
    if (!isMobile()) return;
    var t = e.target;
    if (t && t.closest && t.closest('.dialog-zoomed-gallery__dialog li.product-media-container')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
    }
  }, { capture: true });
  var obs = new MutationObserver(function () {
    var dlg = document.querySelector('.dialog-zoomed-gallery__dialog[open]');
    if (dlg) ensureControls(dlg);
  });
  obs.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-media-container__zoom-button')) {
      setTimeout(function () {
        var dlg = document.querySelector('.dialog-zoomed-gallery__dialog');
        if (dlg) ensureControls(dlg);
      }, 220);
    }
  });
})();
